import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
export interface EntityMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allEntityMaster: [] | null | any;
  dueDiligencecData: {} | null | any;
}
const initialState: EntityMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allEntityMaster: null,
  dueDiligencecData: null,
};
export const entityMasterSlice = createSlice({
  name: 'EntityMaster',
  initialState,
  reducers: {
    setAllEntityMaster: (state, action) => {
      state.allEntityMaster = action.payload.data;
    },
    setEntityMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllEntityMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setDueDiligence: (state, action) => {
      state.dueDiligencecData = action.payload.data;
    },
    reset: (state) => {
      state = initialState;
    },
  },
});
// Action creators are generated for each case reducer function
export const { setAllEntityMaster, setEntityMaster, setAllEntityMasterBySearch, setDueDiligence,reset } = entityMasterSlice.actions;
export const allEntityMasterDetails = (state: RootState) => state.entityMaster.allEntityMaster;
export const getAllEntityMasterDetails = (state: RootState) => state.entityMaster.data;
export const getEntityMasterTotalRecords=(state:RootState)=>state.entityMaster.totalRecords;
export const getAllEntityMasterBySearch = (state: RootState) => state.entityMaster.data;
export const getDueDiligenceData = (state: RootState) => state.entityMaster.dueDiligencecData;
export default entityMasterSlice.reducer;